import { render, staticRenderFns } from "./service-banner-text-card.vue?vue&type=template&id=20742044"
import script from "./service-banner-text-card.vue?vue&type=script&lang=js"
export * from "./service-banner-text-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports